export default {
  metaTitle: "USFans Spreadsheet 2026: Complete Finds & Buying Guide",
  metaDescription:
    "Discover the USFans Spreadsheet — organized finds, category navigation, buying guides, QC tips and shipping info. Independent, updated and easy to use.",
  heroEyebrow: "THE USFANS SPREADSHEET RESOURCE HUB",
  heroH1: "USFans Spreadsheet — Discover Finds, Compare Options & Buy Smarter",
  heroSub:
    "Explore the latest USFans Spreadsheet resources, useful finds, buying guides, QC tips, shipping information, reviews and safety advice — all organized in one easy-to-use hub.",
  heroCta1: "USFans Spreadsheet",
  heroCta2: "Buy It Now",
  heroTrust: "Independent resource · Updated guides · Practical buying information",
  heroBadge: "Trusted starting point for USFans finds",
  categoriesH2: "Browse Product Categories",
  categoriesSub:
    "Jump straight to the section you need on the main website. Choose a category below or use the dropdown above.",
  categoriesGridH2: "Shop by Category",
  categoriesGridSub: "Every category links directly to the matching USFans products on the main website.",
  viewCategory: "View",
  valuePropsH2: "Everything You Need to Know About USFans",
  valuePropsSub: "One hub for the topics buyers ask about most — explained in plain language.",
  vp1Title: "USFans Spreadsheet",
  vp1Desc: "Discover useful finds and organized product resources in one place.",
  vp1Cta: "Explore Spreadsheet",
  vp2Title: "USFans Reviews",
  vp2Desc: "Understand the platform, features, potential risks and important considerations.",
  vp2Cta: "Read USFans Review",
  vp3Title: "Shipping",
  vp3Desc: "Understand shipping methods, estimated costs and tracking considerations.",
  vp3Cta: "View Shipping Guide",
  vp4Title: "QC",
  vp4Desc: "Learn what to check before approving products and confirming an order.",
  vp4Cta: "Learn QC",
  vp5Title: "Safety",
  vp5Desc: "Learn practical ways to reduce common buying risks and stay protected.",
  vp5Cta: "Visit Safety Center",
  vp6Title: "Warehouse",
  vp6Desc: "Understand how warehouse storage and order processing work.",
  vp6Cta: "Read Warehouse Guide",
  seoH2: "Why Use the USFans Spreadsheet?",
  seoP1:
    "The USFans Spreadsheet brings product discovery into one clean place. Instead of jumping between scattered links and outdated pages, you can browse organized categories, compare similar finds, and move straight to the main website when you are ready to buy. It is built to save you time and reduce the guesswork that comes with online shopping.",
  seoP2:
    "We keep this hub independent and easy to use. You will find practical resources on categories, quality checks, shipping, and safety — written in plain language and updated regularly. Whether you are looking for shoes, hoodies, bags, or accessories, the spreadsheet gives you a clear starting point.",
  seoList1: "Organized categories for faster browsing",
  seoList2: "Straightforward buying guidance",
  seoList3: "QC, shipping, and safety basics",
  seoList4: "Regularly updated resources",
  seoReadMore: "Read the Full Guide",
  seoCardTitle: "USFans Spreadsheet 2026: Complete Guide",
  seoCardDesc:
    "What the spreadsheet is, how it works, the main categories, and how to buy with more confidence — in one detailed guide.",
  faqH2: "Frequently Asked Questions",
  faq1Q: "What is the USFans Spreadsheet?",
  faq1A:
    "It is an organized resource that groups USFans finds by category, so you can browse and compare products in one place.",
  faq2Q: "Is the USFans Spreadsheet free to use?",
  faq2A:
    "Yes — browsing the resource is free. You only pay when you decide to buy through the main website.",
  faq3Q: "How do I get to the products?",
  faq3A:
    "Choose a category from the dropdown or the category cards, and you will be taken to the relevant section of the main website.",
  finalCtaH2: "Ready to Explore the USFans Spreadsheet?",
  finalCtaSub: "Browse organized finds, compare categories, and buy smarter — all in one place.",
  finalCtaPrimary: "Explore USFans Spreadsheet",
  finalCtaSecondary: "Visit the Main Website",
  pillarH2: "Pillar Articles & Guides",
  pillarSub: "Our most-read USFans resources — reviews, shipping, QC, safety, and buying tips in one place.",
  pillarRead: "Read guide",
  p1Title: "USFans Review 2026",
  p1Desc: "Is USFans legit and safe? A plain-language look at how it works and what to check.",
  p2Title: "USFans Shipping Cost Guide",
  p2Desc: "What affects shipping price and how to compare options before you order.",
  p3Title: "USFans Coupon Guide",
  p3Desc: "How coupons work and where to verify current promotions safely.",
  p4Title: "USFans Discount Code Guide",
  p4Desc: "How to find and check current discount codes before you buy.",
  p5Title: "USFans Warehouse Guide",
  p5Desc: "How warehouse storage, QC and order processing work behind the scenes.",
  p6Title: "Is USFans Legit?",
  p6Desc: "A balanced look at trust, common risks and how to protect yourself.",
  p7Title: "USFans QC Guide",
  p7Desc: "What to inspect before approving products and confirming an order.",
  p8Title: "USFans Buying Guide",
  p8Desc: "A step-by-step path to ordering with more confidence.",
  p9Title: "USFans Safety Center",
  p9Desc: "Practical ways to reduce the most common buying risks.",
  p10Title: "USFans Tracking & Shipping",
  p10Desc: "Understand tracking and shipping basics for your orders.",
};